import { SellerFilterOption } from '@/components/SellerFilter/SellerFilterUi';

export type FilterUi = {
  orderId: string;
  startDate?: Date;
  endDate?: Date;
  sellers: SellerFilterOption[];
  kamFilterOptions: KamOptionUi[];
  selectedKamIds: string[];
  statusOptions: StatusOptionUi[];
  selectedStatusId: string;
  remisionStatusOptions: StatusOptionUi[];
  remissionStatusId: string;
};

export type StatusOptionUi = {
  statusId: string;
  statusName: string;
};

export type KamOptionUi = {
  id: string;
  name: string;
};

export const initialState: FilterUi = {
  orderId: '',
  sellers: [],
  kamFilterOptions: [],
  selectedKamIds: [],
  statusOptions: [],
  selectedStatusId: '',
  remissionStatusId: '',
  remisionStatusOptions: [
    {
      statusId: 'true',
      statusName: 'Recibida',
    },
    {
      statusId: 'false',
      statusName: 'Pendiente',
    },
  ],
};
